import React from 'react'
import "../Styles/Tour_information.css"
import { NavLink, Outlet } from 'react-router-dom'

function Tour_information() {
  return (
    <div className='tourInfo_container'>
      <h2 className='tourInfo_title'>Franchise Information</h2>
      <div className='tourInfo_card'>
        <div className='tourInfo_section_navber' style={{overflowX:"auto"}}>
          <NavLink to={"/profile/franchise"} end className={({ isActive }) => 
              isActive ? "tourInfo_link active" : "tourInfo_link" 
            }>
            Tour Commisssion
          </NavLink>
          <NavLink to={"/profile/franchise/hotel"} className={({ isActive }) =>
              isActive ? "tourInfo_link active" : "tourInfo_link"
            }>
            Hotel Commission
          </NavLink>
          <NavLink to={"/profile/franchise/transport"} className={({ isActive }) =>
              isActive ? "tourInfo_link active" : "tourInfo_link"
            }>
            Transport Commission
          </NavLink>
          <NavLink to={"/profile/franchise/activity"} className={({ isActive }) =>
              isActive ? "tourInfo_link active" : "tourInfo_link"
            }>
            Activity Commission
          </NavLink>
        </div>
        <hr/>
        {/* tour info content */}
        <div>
          <Outlet/>
        </div>
        </div>
    </div>
  )
}

export default Tour_information